/* Waxman's Gym Ratio Calculator Copyright (C) 2017 Waxman's Gym

This program is free software: you can redistribute it and/or modify
it under the terms of the GNU General Public License as published by
the Free Software Foundation, either version 3 of the License, or
(at your option) any later version.

This program is distributed in the hope that it will be useful,
but WITHOUT ANY WARRANTY; without even the implied warranty of
MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
GNU General Public License for more details.

You should have received a copy of the GNU General Public License
along with this program.  If not, see <http://www.gnu.org/licenses/>.*/

import React from 'react';
import { Button, Modal } from 'react-bootstrap';

class Notes extends React.Component {
    constructor(props) {
        super(props);
        this.state = { showModal: false };
        this.close = this.close.bind(this);
        this.open = this.open.bind(this);
    }

    close() {
        this.setState({ showModal: false });
    }

    open() {
        this.setState({ showModal: true });
    }

    render() {
        return (
            <div>
                <Button bsStyle="default" onClick={this.open}> Saiba mais </Button>

                <Modal show={this.state.showModal} onHide={this.close} aria-labelledby="contained-modal-title-lg">
                    <Modal.Header closeButton style={{ backgroundImage: `url(/img/prancheta_2.png)` }}>
                        <Modal.Title> Saiba mais </Modal.Title>
                    </Modal.Header>
                    <Modal.Body style={{ backgroundImage: `url(/img/prancheta_2.png)` }}>
                        <div id="notesbody">
                            <h3>Objetivo desta calculadora</h3>
                            <p>
                                Esta calculadora foi criada para avaliar o equilíbrio de carga nos movimentos de LPO, bem como dar um diagnóstico de possíveis pontos de melhoria.
                            </p>

                            <p>
                                É muito importante manter o equilíbrio entre técnica e força. Uma pessoa sem este equilíbrio pode ser que tenha muita força porém está lhe faltando técnica, pode ser que tenha uma técnica excelente porém esteja lhe faltando força ou talvez até mesmo que tenha um excelente técnica em determinado movimento e lhe falte técnica em outro.
                            </p>

                            <p>
                                Literaturas e autores de renome ao longo dos anos identificaram que as relações de peso entre os movimentos são extremamente úteis e precisas para avaliar o atleta e dar um direcionamento sobre qual área foco deve ser desenvolvida.
                                Identificando e conhecendo as suas maiores dificuldades você conseguirá focar exatamente onde precisa para aumentar as suas chances de atingir seus objetivos.
                            </p>

                            <h3>Referências</h3>
                            <p>
                                Tanto o código fonte desta calculadora como o resumo técnico das informações contidas aqui, são de autoria da Waxman's Gym LLC, uma academia especializada em levantamento de peso localizada em Lawndale na Califórnia.
                            </p>

                            <hr />

                            <p className="small text-muted">
                                As informações e sugestões fornecidas por esta ferramenta tem o propósito apenas informativo. Nem a Waxman's Gym LLC nem o RX54 se responsabilizam pelo uso das informações aqui apresentadas. Como não sabemos quem você é, seu histórico e suas dificuldades, para sua segurança recomendamos o acompanhameto de um profissional para a prática de LPO.
                            </p>

                            {/* <h3>3. Reporting Bugs</h3>
                            <p>
                                Please send any issues to <a href="mailto:support@waxmansgym.com?Subject=Calculator">support@waxmansgym.com</a>.
                            </p>
                            <p>
                                For the technically inclined, you can also submit bugs on our <a href="https://github.com/waxmansgym/ratio-calculator/issues" target="_blank">Github Issue Tracker</a>.
                            </p>

                            <hr />

                            <p className="small text-muted">
                                You expressly acknowledge and agree that Waxman's Gym LLC and its
                                agents, affiliates, and associates make no representations or
                                warranties as to the suitability/safety of the information provided
                                here since we have no idea who you are or what your deal is. Prior
                                to participating in any program, activity, exercise discussed,
                                recommended, or suggested on this site, you should seek the advice
                                of your physician and/or other qualified professionals. At all
                                times, your reliance on the information, advice, ideas, and
                                suggestions on this page comes at your sole discretion and risk.
                            </p> */}


                        </div>
                    </Modal.Body>
                    <Modal.Footer style={{ backgroundImage: `url(/img/prancheta_2.png)` }}>
                        <Button onClick={this.close}>Fechar</Button>
                    </Modal.Footer>
                </Modal>
            </div>
        );
    }
}

export { Notes };
// vim: ft=javascript.jsx



/** WEBPACK FOOTER **
 ** ./src/components/notes.js
 **/